export const DEFAULT_CLASSROOM_MEDIA_URL: string = 'assets/images/user.png';

export const DEFAULT_DIGITAL_MEDIA_URL: string = 'assets/icons/logo.png';
